import { IBaseAction, IPromiseParam } from '../base';
import { put, call, takeEvery } from 'redux-saga/effects';
import * as types from './actionTypes.organization';
import * as _ from 'lodash';
import * as errorSaga from '../errors/saga.errors';
import * as userSaga from '../user/saga.user';
import { OrganizationApi } from '../../api/OrganizationApi';
import { push, replace } from 'react-router-redux';
import { IAddOrganizationMemberParams, ICreateOrganizationParams, IRemoveOrganizationMemberParams, IUpdateOrganizationParams, IVerifyOrganizationMemberParams } from './actions.organization';
import ToasterService from '../../services/ToasterService';
import { getEmailFromUrl } from '../../services/mini/getEmailFromUrl';
import { routeInfo } from '../../routeInfo';

export function* watch() {
    yield takeEvery<ICreateOrganizationParams & IPromiseParam & IBaseAction>(types.CREATE_ORGANIZATION_REQ, createOrganization);
    yield takeEvery<IUpdateOrganizationParams & IPromiseParam & IBaseAction>(types.UPDATE_ORGANIZATION_REQ, updateOrganization);
    yield takeEvery<IPromiseParam & IBaseAction>(types.REMOVE_ORGANIZATION_REQ, removeOrganization);
    yield takeEvery<IAddOrganizationMemberParams & IPromiseParam & IBaseAction>(types.ADD_ORGANIZATION_MEMBER_REQ, addOrganizationMember);
    yield takeEvery<IRemoveOrganizationMemberParams & IPromiseParam & IBaseAction>(types.REMOVE_ORGANIZATION_MEMBER_REQ, removeOrganizationMember);
    yield takeEvery<IVerifyOrganizationMemberParams & IPromiseParam & IBaseAction>(types.VERIFY_ORGANIZATION_MEMBER_REQ, verifyOrganizationMember);
}

export function* createOrganization({ name, resolve, reject }: ICreateOrganizationParams & IPromiseParam) {
    try {
        yield call(OrganizationApi.createOrganization, { name });
        yield userSaga.getProfile({});
        yield put({ type: types.CREATE_ORGANIZATION_OK });

    } catch (error) {
        yield errorSaga.putError(error);
        yield put({ type: types.CREATE_ORGANIZATION_ERR });
    }
}

export function* updateOrganization({ name, resolve, reject }: IUpdateOrganizationParams & IPromiseParam) {
    try {
        yield call(OrganizationApi.updateOrganization, { name });
        yield userSaga.getProfile({});
        yield put({ type: types.UPDATE_ORGANIZATION_OK });

    } catch (error) {
        yield errorSaga.putError(error);
        yield put({ type: types.UPDATE_ORGANIZATION_ERR });
    }
}

export function* removeOrganization({ resolve, reject }: IPromiseParam) {
    try {
        yield call(OrganizationApi.removeOrganization);
        yield userSaga.getProfile({});
        yield put({ type: types.REMOVE_ORGANIZATION_OK });

    } catch (error) {
        yield errorSaga.putError(error);
        yield put({ type: types.REMOVE_ORGANIZATION_ERR });
    }
}


export function* addOrganizationMember({ email, resolve, reject }: IAddOrganizationMemberParams & IPromiseParam) {
    try {
        yield call(OrganizationApi.addOrganizationMember, { email });
        yield userSaga.getProfile({});
        yield put({ type: types.ADD_ORGANIZATION_MEMBER_OK });
    } catch (error) {
        yield errorSaga.putError(error);
        yield put({ type: types.ADD_ORGANIZATION_MEMBER_ERR });
    }
}

export function* removeOrganizationMember({ email, resolve, reject }: IRemoveOrganizationMemberParams & IPromiseParam) {
    try {
        yield call(OrganizationApi.removeOrganizationMember, { email });
        yield userSaga.getProfile({});
        yield put({ type: types.REMOVE_ORGANIZATION_MEMBER_OK });

    } catch (error) {
        yield errorSaga.putError(error);
        yield put({ type: types.REMOVE_ORGANIZATION_MEMBER_ERR });
    }
}


export function* verifyOrganizationMember({ code, resolve, reject }: IVerifyOrganizationMemberParams & IPromiseParam) {
    try {
        const emailFromUrl = getEmailFromUrl();
        const savedEmail = localStorage.getItem('alan_email');
        if (savedEmail && emailFromUrl && savedEmail.toLowerCase() === emailFromUrl.toLowerCase()) {
            yield userSaga.authorizeUser();
        } else {
            yield put(push(routeInfo.loginWithEmail.url(emailFromUrl)));
        }
        const { orgName } = yield call(OrganizationApi.verifyOrganizationMember, { code });
        ToasterService.showInfo({ title: `You've accepted invitation to become a member of the <b>${orgName}</b> organization` });

        yield put({ type: types.VERIFY_ORGANIZATION_MEMBER_OK });
    } catch (error) {
        yield errorSaga.putError(error);
        yield put({ type: types.VERIFY_ORGANIZATION_MEMBER_ERR });
    }
}